import { RiDashboardFill } from "react-icons/ri";
import { MdOutlineTableView } from "react-icons/md";

const links = [
  {
    url: "/",
    name: "dashboard",
    Icon: RiDashboardFill,
  },
  {
    url: "/tables",
    name: "tables",
    Icon: MdOutlineTableView,
  },
];

export default links;
